import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import "@fontsource/roboto/300.css"; // Light weight
import "@fontsource/roboto/500.css"; // Medium weight
import "@fontsource/roboto/700.css"; // Bold weight
import "@fontsource/roboto/900-italic.css"; // Black italic weight

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  //<React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>

  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.addEventListener("error", (event) => {
  const msg = event.message || "";
  if (
    msg.includes("Loading chunk") ||
    msg.includes("Failed to fetch dynamically imported module")
  ) {
    const alreadyReloaded = sessionStorage.getItem("chunk_error_reload");
    if (!alreadyReloaded) {
      sessionStorage.setItem("chunk_error_reload", "1");
      window.location.reload();
    }
  }
});
